import { getNum } from "./util";

function genTitle(id) {
    return {
        name: "Title",
        methods: { getNum, getId: () => id },
        template: `<span>{{ $i18n.t("ticket.menu." + getId(), { num : getNum(getId()) }) }}</span>`
    };
}

export default () => ({
    permit: "ticket", // 可以针对父级直接去掉权限,
    children: [
        {
            path: "all",
            menu: { title: genTitle("all") },
            permit: "ticket.all",
            component: () => import("./all")
        },
        {
            path: "wait",
            menu: { title: genTitle("wait") },
            permit: "ticket.unassigned",
            component: () => import("./wait")
        },
        {
            path: "todo",
            meta: { current: "todo" },
            menu: { title: genTitle("todo") },
            permit: "ticket.myopen",
            component: () => import("@/views/ticket/todo")
        },
        {
            path: "done",
            meta: { current: "done" },
            menu: { title: genTitle("done") },
            permit: "ticket.myclosed", // 也可以配置子级的权限
            component: () => import("@/views/ticket/done")
        },
        {
            path: "auto",
            menu: { title: genTitle("auto") },
            permit: "ticket.autoreply",
            component: () => import("./auto")
        }
    ]
});
